/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'
import { makeCategory } from '../../../../usecases/categories/load-category-factory'
import MenuOrganization from '../../../../../presentation/pages/dashboard/menu/menu-organization'
import { makeMenuOption } from '../../../../usecases/menu-options/load-menu-option-factory'
import { stringToBoolean } from '../../../../../presentation/helpers/helper-string'
import { theme } from '../../../../../presentation/styles/theme'
import { useLoading } from '../../../../../presentation/contexts/loading'

type CategoryOption = {
  label: string;
  value: string;
}

const MakeMenuOrganization = () => {
  const [categories, setCategories] = useState<string[]>([])
  const [initialFormData, setInitialFormData] = useState<any>(null)
  const [categoriesOptions, setCategoriesOptions] = useState<CategoryOption[]>([])
  const [menuOptionForm, setMenuOptionForm] = useState<any>(null)
  const { setHeader } = usePage()
  const { me } = useMe()
  const { onSetLoading } = useLoading()
  const { setIsShowing, setText, setType } = useSnackbar()

  const loadCategories = async () => {
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeCategory(stablishmentId).load()

      setCategoriesOptions(response.categories.map((category: any) => ({
        value: category.id,
        label: category.name,
      })))
    } catch (error) {
      console.log(error)
    }
  }

  const loadMenuOption = async () => {
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const { menuOption } = await makeMenuOption(stablishmentId).load()
      if (menuOption) {
        const initial = {
          title: menuOption.title,
          description: menuOption.description,
          hasFile: String(!menuOption.hasFile),
          file: menuOption.file,
        }
        setCategories(menuOption.categories
          .sort((a: any, b: any) => a.position - b.position)
          .map((c: any) => String(c.id)))
        setInitialFormData(initial)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    (async () => {
      setHeader({
        title: 'Organização do cardápio',
        goTo: null,
      })
      try {
        onSetLoading(true)
        await loadCategories()
        await loadMenuOption()
      } catch (error) {
        console.log(error)
      } finally {
        onSetLoading(false)
      }
    })()
  }, [me])

  const dataForm = [
    {
      items: [
        {
          name: 'title',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          title: 'Título do cardápio',
          label: 'Título do cardápio',
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'description',
          component: 'Textarea',
          value: '',
          placeholder: 'Digite aqui',
          title: 'Descrição',
          label: 'Descrição',
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'hasFile',
          component: 'InputRadio',
          value: '',
          placeholder: 'Digite aqui',
          title: 'Inserir logo já utilizada no sistema',
          label: 'Inserir logo já utilizada no sistema',
          required: true,
          options: [{ label: 'Sim', value: 'true' }, { label: 'Não', value: 'false' }],
        },
        {
          name: 'file',
          label: 'Insira uma nova logo',
          title: 'Insira uma nova logo',
          component: 'InputUpload',
          required: true,
          dependencies: [{ name: 'hasFile', value: 'false' }],
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar',
          submittingText: 'Salvando...',
          style: { background: theme.colors.blue, width: '187px', marginTop: '45px' },
        },
      ],
    },
  ]

  const onSubmit = async (): Promise<void> => {
    const formData = new FormData()
    const itemToSubmit = new Map(Object.entries(menuOptionForm))
    itemToSubmit.set('hasFile', !stringToBoolean(menuOptionForm.hasFile))

    if (itemToSubmit.get('file') === ''
      || (itemToSubmit.get('file') as any)?.id
      || itemToSubmit.get('file') === null) {
      itemToSubmit.delete('file')
    }

    const formatCategories = (categoryGroup: string[]) => categoryGroup.map((c, index) => ({
      id: +c,
      position: index + 1,
    }))

    function addItemInFormData(value: any, key: string) {
      formData.append(key, value)
    }

    itemToSubmit.forEach(addItemInFormData)

    if (categories) {
      formData.append('categories', JSON.stringify(formatCategories(categories)))
    }

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      if (initialFormData) {
        await makeMenuOption(stablishmentId).patch(formData)
      } else {
        await makeMenuOption(stablishmentId).post(formData)
      }
      await loadMenuOption()
      setType('success')
      setText('Salvo com sucesso!')
      setIsShowing(true)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <MenuOrganization
      initialData={initialFormData}
      dataForm={dataForm}
      menuOptionsData={setMenuOptionForm}
      onSubmit={onSubmit}
      categoriesOptions={categoriesOptions}
      categories={categories}
      setCategories={setCategories}
    />
  )
}

export default MakeMenuOrganization
